import React from 'react'
import { Tab, Menu, Label } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

import StreamingData from '../Drive/Cards/StreamingData'

class StreamContent extends React.Component {

    async setNotification(type) {
        window.scrollTo(0, 0)

        let payload = {
            name: this.props.filterQuery.name,
            serviceName: this.props.filterQuery.serviceName,
            sortingType: this.props.filterQuery.sortingType,
            limit: this.props.filterQuery.limit,
            type: type
        }
        await dispatch.notifications.setFilterQueryData(payload)
        dispatch.notifications.getEventStreamByOrganization(payload);
    }

    setNotificationForCommunity(type) {
        window.scrollTo(0, 0)
        let payL = {
            limit: 10,
            type: type,
            role: this.props.selectedOrganisation.role
        }
        dispatch.notifications.getEventStreamForCommunity(payL);
    }

    render() {
        const { loaderEventData, selectedOrganisation, notificationsCount, selectedAccount, initiativeOwnerDetails, filterQuery } = this.props
        let panes = []
        if (this.props.eventPage === "home") {
            panes = [
                {
                    menuItem: <Menu.Item onClick={() => this.setNotification("all")} key='All'> All </Menu.Item>,
                    render: () => <StreamingData
                        filterQuery={filterQuery}
                        show="all"
                        initiativeOwnerDetails={initiativeOwnerDetails}
                        selectedAccount={selectedAccount}
                        notificationsCount={notificationsCount}
                        selectedOrganisation={selectedOrganisation}
                        loaderEventData={loaderEventData}
                        eventStreamArray={this.props.eventStreamArray}
                        eventPage={this.props.eventPage}
                        noEventDataFound={this.props.noEventDataFound}
                        currentOrganization={this.props.currentOrganization}
                        user={this.props.user}
                        singlePlaybookEntry={this.props.singlePlaybookEntry}


                    />
                },
                {
                    menuItem: <Menu.Item onClick={() => this.setNotification("my")} key='My'> My</Menu.Item>,
                    render: () => <StreamingData
                        filterQuery={filterQuery} show="my"
                        initiativeOwnerDetails={initiativeOwnerDetails}
                        selectedAccount={selectedAccount}
                        notificationsCount={notificationsCount}
                        selectedOrganisation={selectedOrganisation}
                        loaderEventData={loaderEventData}
                        eventStreamArray={this.props.eventStreamArray}
                        eventPage={this.props.eventPage}
                        noEventDataFound={this.props.noEventDataFound}
                        currentOrganization={this.props.currentOrganization}
                        user={this.props.user}
                        singlePlaybookEntry={this.props.singlePlaybookEntry}


                    />
                },
            ]
        } else if (this.props.eventPage === "organization") {
            panes = [
                {
                    menuItem: <Menu.Item onClick={() => this.setNotificationForCommunity("all")} key='All'> All
                    <Label size="small">{this.props.eventStreamCount && this.props.eventStreamCount.allCount ? this.props.eventStreamCount.allCount : 0}</Label>
                    </Menu.Item>,
                    render: () => <StreamingData
                        filterQuery={filterQuery}
                        show="all"
                        initiativeOwnerDetails={initiativeOwnerDetails}
                        selectedAccount={selectedAccount}
                        notificationsCount={notificationsCount}
                        selectedOrganisation={selectedOrganisation}
                        loaderEventData={loaderEventData}
                        eventStreamArray={this.props.eventStreamArray}
                        eventPage={this.props.eventPage}
                        noEventDataFound={this.props.noEventDataFound}
                        currentOrganization={this.props.currentOrganization}
                        user={this.props.user}
                        singlePlaybookEntry={this.props.singlePlaybookEntry}


                    />
                },
                {
                    menuItem: <Menu.Item onClick={() => this.setNotificationForCommunity("initiatives")} key='initiatives'> Initiatives
                    <Label size="small">{this.props.eventStreamCount.initiativesCount}</Label>
                    </Menu.Item>,
                    render: () => <StreamingData
                        filterQuery={filterQuery} show="initiatives"
                        initiativeOwnerDetails={initiativeOwnerDetails}
                        selectedAccount={selectedAccount}
                        notificationsCount={notificationsCount}
                        selectedOrganisation={selectedOrganisation}
                        loaderEventData={loaderEventData}
                        eventStreamArray={this.props.eventStreamArray}
                        eventPage={this.props.eventPage}
                        noEventDataFound={this.props.noEventDataFound}
                        currentOrganization={this.props.currentOrganization}
                        user={this.props.user}
                        singlePlaybookEntry={this.props.singlePlaybookEntry}


                        
                    />
                },
                {
                    menuItem: <Menu.Item onClick={() => this.setNotificationForCommunity("contents")} key='contents'> Content
                     <Label size="small">{this.props.eventStreamCount.contentsCount}</Label>
                    </Menu.Item>,
                    render: () => <StreamingData
                        filterQuery={filterQuery} show="contents"
                        initiativeOwnerDetails={initiativeOwnerDetails}
                        selectedAccount={selectedAccount}
                        notificationsCount={notificationsCount}
                        selectedOrganisation={selectedOrganisation}
                        loaderEventData={loaderEventData}
                        eventStreamArray={this.props.eventStreamArray}
                        eventPage={this.props.eventPage}
                        noEventDataFound={this.props.noEventDataFound}
                        currentOrganization={this.props.currentOrganization}
                        user={this.props.user}
                        singlePlaybookEntry={this.props.singlePlaybookEntry}


                    />
                },
                {
                    menuItem: <Menu.Item onClick={() => this.setNotificationForCommunity("practices")} key='practices'> Playbooks
                     <Label size="small">{this.props.eventStreamCount.practicesCount}</Label>
                    </Menu.Item>,
                    render: () => <StreamingData
                        filterQuery={filterQuery} show="practices"
                        initiativeOwnerDetails={initiativeOwnerDetails}
                        selectedAccount={selectedAccount}
                        notificationsCount={notificationsCount}
                        selectedOrganisation={selectedOrganisation}
                        loaderEventData={loaderEventData}
                        eventStreamArray={this.props.eventStreamArray}
                        eventPage={this.props.eventPage}
                        noEventDataFound={this.props.noEventDataFound}
                        currentOrganization={this.props.currentOrganization}
                        user={this.props.user}
                        singlePlaybookEntry={this.props.singlePlaybookEntry}


                    />
                },
            ]
        }

        return (
            <div>
                <Tab className={`streamTabs ${this.props.eventPage === "home" ? "two-block" : "four-block"}`}
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                />
            </div>
        )
    }
}

export default StreamContent;